import Vue from 'vue'
import VueRouter from 'vue-router'

import middlewarePipeline from './middleware/middlewarePipeline'

import authRoutes from './auth'
import memberRoutes from './member'
import providerRoutes from './provider'
import adminRoutes from './admin'
import publicRoutes from './public'

Vue.use(VueRouter)

const routes = [
    ...authRoutes,
    ...memberRoutes,
    ...providerRoutes,
    ...adminRoutes,
    ...publicRoutes
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior(to) {
        if (to.hash) {
            return window.scrollTo({
                top: document.querySelector(to.hash).offsetTop,
                behavior: 'smooth'
            })
        } else {
            return { x: 0, y: 0 }
        }
    },
    routes
})

router.beforeEach((to, from, next) => {
    if (to.meta.middleware) {
        const middleware = Array.isArray(to.meta.middleware) ? to.meta.middleware : [to.meta.middleware]
        const context = { to, from, next }
        return middleware[0]({
            ...context,
            next: middlewarePipeline(context, middleware, 1)
        })
    } else {
        next()
    }
})

export default router
